<template>

    <div class="l-dashboard">
        <header class="l-dashboard__header">
            <the-dashboard-navbar></the-dashboard-navbar>
        </header>
        <div class="l-dashboard__container">
            <the-dashboard-sidebar></the-dashboard-sidebar>
            <main class="l-dashboard__main">
                <v-loader :loading="pageLoading"></v-loader>
                <div class="l-dashboard__scroll" id="dashboard-scroll">
                    <slot></slot>
                </div>
            </main>
        </div>
    </div>

</template>


<script>

import {mapGetters} from 'vuex'
import TheDashboardNavbar from 'Components/Dashboard/TheDashboardNavbar'
import TheDashboardSidebar from 'Components/Dashboard/TheDashboardSidebar'

import VLoader from 'Components/VLoader'

export default {

    name: 'LayoutDashboard',

    created() {
        document.body.classList.remove('loading');
    },

    computed: {
        ...mapGetters(['pageLoading'])
    },

    components: {
        TheDashboardNavbar,
        TheDashboardSidebar,
        VLoader
    }

}

</script>


<style lang="scss">

@import '~Style/_utils.scss';

.l-dashboard {
    display: flex;
    flex-direction: column;
    height: 100vh;
    overflow: hidden;

    @include bp($screen-lg) {
        padding-bottom: 50px;
    }
    @include bp($screen-sm) {
        padding-bottom: 40px;
    }
    &__header {
        width: 100%;
    }
    &__container {
        flex-grow: 999;
        display: flex;
        align-items: stretch;
    }
    &__main {
        position: relative;
        display: flex;
        flex-grow: 999;
    }
    &__scroll {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        overflow: auto;
    }
}
.page {
    display: flex;
    flex-direction: column;
    width: 100%;
    min-height: 100%;
    padding: 50px;

    @include bp($screen-md) {
        padding: 30px 0;
    }
    @include bp($screen-md) {
        padding: 20px 0;
    }
}

</style>
